import React from "react";

const TemarioDiplomaturaMedicinaLaboral = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Contexto del Sector Extractivo y Perfil del Trabajador"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Industria hidrocarburífera argentina: Vaca Muerta, estructura y actores clave"}</span></li>
                <li><span className="fw-light">{"Minería metalífera, a cielo abierto y subterránea: tipos y riesgos diferenciales"}</span></li>
                <li><span className="fw-light">{"Perfil epidemiológico del trabajador extractivo y estadísticas SRT"}</span></li>
                <li><span className="fw-light">{"Condiciones de trabajo: turnos, campamento, rotación y aislamiento"}</span></li>
                <li><span className="fw-light">{"Accidentabilidad y mortalidad comparada con otras industrias"}</span></li>
                <li><span className="fw-light">{"Determinantes sociales y salud mental en zonas de explotación"}</span></li>
                <li><span className="fw-light">{"El médico en la industria extractiva: roles, funciones y tensiones éticas"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Agentes de Riesgo y Toxicología Industrial"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Benceno y BTX: carcinogénesis hematológica, TLV-TWA y biomarcadores urinarios"}</span></li>
                <li><span className="fw-light">{"Sílice cristalina: silicosis, EPOC y cáncer de pulmón"}</span></li>
                <li><span className="fw-light">{"H2S: anosmia adquirida, niveles de alarma, edema pulmonar y muerte súbita"}</span></li>
                <li><span className="fw-light">{"NORM: materiales radiactivos naturales, radón y dosimetría individual"}</span></li>
                <li><span className="fw-light">{"Ruido industrial e hipoacusia neurosensorial"}</span></li>
                <li><span className="fw-light">{"Estrés térmico, WBGT, golpe de calor y falla renal aguda"}</span></li>
                <li><span className="fw-light">{"Arsénico, plomo y mercurio en minería: vigilancia biológica"}</span></li>
                <li><span className="fw-light">{"Vibraciones, polvo de carbón y minería de litio: riesgos emergentes"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Enfermedades Profesionales y Nexo Causal"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Enfermedades del listado y fuera de listado: criterios y jurisprudencia"}</span></li>
                <li><span className="fw-light">{"Nexo causal, historia ocupacional y criterios de Bradford Hill"}</span></li>
                <li><span className="fw-light">{"Neumoconiosis: clasificación radiológica OIT, espirometría y seguimiento"}</span></li>
                <li><span className="fw-light">{"Cáncer ocupacional: leucemia por benceno, mesotelioma y cáncer de pulmón"}</span></li>
                <li><span className="fw-light">{"Hipoacusia neurosensorial: audiometría, STS-OSHA y evaluación de incapacidad"}</span></li>
                <li><span className="fw-light">{"Neuropatías y hepatopatías tóxicas: diagnóstico diferencial"}</span></li>
                <li><span className="fw-light">{"Incapacidad laboral permanente: baremo SRT y porcentaje de incapacidad"}</span></li>
                <li><span className="fw-light">{"Subregistro en Argentina: magnitud, causas y responsabilidad del médico"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Vigilancia Médica y Prevención"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Exámenes preocupacionales, periódicos y de egreso: contenidos y periodicidad"}</span></li>
                <li><span className="fw-light">{"Protocolos por agente: benceno, sílice, ruido y NORM"}</span></li>
                <li><span className="fw-light">{"Historia clínica laboral, legajo de salud y confidencialidad"}</span></li>
                <li><span className="fw-light">{"Vigilancia epidemiológica colectiva y detección de clusters"}</span></li>
                <li><span className="fw-light">{"Jerarquía de controles NIOSH e ISO 45001"}</span></li>
                <li><span className="fw-light">{"Retiro preventivo y criterios de reubicación médica"}</span></li>
                <li><span className="fw-light">{"Salud mental: PHQ-9, GAD-7 y consumos problemáticos en campamento"}</span></li>
                <li><span className="fw-light">{"Telemedicina en zonas remotas: herramientas y limitaciones"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Emergencias Médicas en Campo"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"RCP básica y avanzada en entorno industrial"}</span></li>
                <li><span className="fw-light">{"Manejo del shock: hipovolémico, séptico y anafiláctico"}</span></li>
                <li><span className="fw-light">{"Quemados: clasificación, primeros auxilios y criterios de derivación"}</span></li>
                <li><span className="fw-light">{"Trauma en campo: inmovilización, hemorragia y politraumatizado"}</span></li>
                <li><span className="fw-light">{"Obstrucción de vía aérea: maniobras y dispositivos disponibles"}</span></li>
                <li><span className="fw-light">{"Emergencias cardiovasculares: IAM, arritmias y edema agudo de pulmón"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Emergencias Industriales y Gestión en Zonas Remotas"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Intoxicación por H2S: rescate con EPP, descontaminación y antídotos"}</span></li>
                <li><span className="fw-light">{"Exposición aguda a benceno y COVs: manejo clínico inicial"}</span></li>
                <li><span className="fw-light">{"Derrames de hidrocarburos: protección personal y primeros auxilios"}</span></li>
                <li><span className="fw-light">{"Explosiones e incendios: triage, quemados y barotrauma"}</span></li>
                <li><span className="fw-light">{"Rescate en espacios confinados: protocolo y límites del médico"}</span></li>
                <li><span className="fw-light">{"Gestión del enfermo crónico en campamento"}</span></li>
                <li><span className="fw-light">{"Farmacia de campamento: medicamentos esenciales y stock mínimo"}</span></li>
                <li><span className="fw-light">{"Criterios de evacuación médica: terrestre vs. aérea"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Salud Mental y Consumos Problemáticos en la Industria Extractiva"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Determinantes de la salud mental en la industria extractiva: turnos, aislamiento y campamento"}</span></li>
                <li><span className="fw-light">{"Trastornos más frecuentes: depresión, ansiedad, TEPT e insomnio crónico"}</span></li>
                <li><span className="fw-light">{"Consumo problemático de alcohol: AUDIT, criterios diagnósticos e intervención breve"}</span></li>
                <li><span className="fw-light">{"Consumo de drogas: cannabis, cocaína, psicofármacos y estimulantes"}</span></li>
                <li><span className="fw-light">{"Consumo problemático de juego en contexto de campamento"}</span></li>
                <li><span className="fw-light">{"Violencia laboral, acoso y factores de riesgo psicosocial"}</span></li>
                <li><span className="fw-light">{"Instrumentos de tamizaje: PHQ-9, GAD-7, AUDIT y DAST"}</span></li>
                <li><span className="fw-light">{"Intervención breve motivacional y aplicación práctica"}</span></li>
                <li><span className="fw-light">{"Redes de derivación en Argentina: SEDRONAR y centros de salud mental"}</span></li>
                <li><span className="fw-light">{"Salud mental del médico de territorio: burnout, desgaste empático y autocuidado"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Marco Legal y Rol del Médico Auditor"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Ley 19.587 y Decreto 351/79: obligaciones del empleador en higiene y seguridad"}</span></li>
                <li><span className="fw-light">{"Ley 24.557 y sistema de riesgos del trabajo"}</span></li>
                <li><span className="fw-light">{"Resolución SRT 37/2010 y exámenes médicos obligatorios"}</span></li>
                <li><span className="fw-light">{"Resolución SRT 295/03 y valores límite de exposición"}</span></li>
                <li><span className="fw-light">{"Ley 27.802, indemnizaciones y Fondo de Asistencia Laboral"}</span></li>
                <li><span className="fw-light">{"RIGI y estabilidad regulatoria con impacto en salud laboral"}</span></li>
                <li><span className="fw-light">{"Principio in dubio pro operario y aplicación práctica"}</span></li>
                <li><span className="fw-light">{"Aspectos éticos: confidencialidad, conflicto de intereses y deberes"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Proyecto Final Integrador"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Diseño de un programa completo de salud laboral para una empresa extractiva"}</span></li>
                <li><span className="fw-light">{"Auditoría de programas existentes: indicadores, brechas y recomendaciones"}</span></li>
                <li><span className="fw-light">{"Presentación de caso: diagnóstico, nexo causal y propuesta de acción"}</span></li>
                <li><span className="fw-light">{"Cambio climático como factor de riesgo laboral emergente"}</span></li>
                <li><span className="fw-light">{"Panel con médicos de campo, auditores y responsables de ART"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaMedicinaLaboral;
